import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthHero from '../components/AuthHero';
import FlowGuard from '../../components/FlowGuard';

const JoinSuccessContent: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get user name from route state
    const userName = location.state?.userName || 'User';
    const companyName = location.state?.companyName || '';

    return (
        <div className="min-h-screen bg-[#F8F9FB] flex">
            {/* Left Side - Success Message */}
            <div className="w-full lg:flex-1 flex items-center justify-center p-4 sm:p-8">
                <div className="w-full max-w-md">
                    {/* Logo */}
                    <div className="mb-8">
                        <img
                            src="/branding/logo_blue.svg"
                            alt="Hush"
                            onClick={() => navigate('/')}
                            className="h-10 w-auto cursor-pointer"
                        />
                    </div>

                    {/* Welcome Message */}
                    <h1
                        style={{
                            fontFamily: 'Manrope',
                            fontWeight: 700,
                            fontSize: '32px',
                            color: '#015FA6',
                            marginBottom: '12px'
                        }}
                    >
                        Welcome to {companyName || userName} on Hush
                        <span role="img" aria-label="party" style={{ marginLeft: '8px' }}>
                            🎉
                        </span>
                    </h1>

                    {/* Subtitle */}
                    <p
                        style={{
                            fontFamily: 'SF Pro, Manrope',
                            fontWeight: 400,
                            fontSize: '14px',
                            lineHeight: '150%',
                            color: 'rgba(1, 95, 166, 0.7)',
                            marginBottom: '32px'
                        }}
                    >
                        Next, let's create your personal recruiter account.
                    </p>

                    {/* Go to Dashboard Button */}
                    <button
                        onClick={() => navigate('/companies/dashboard')}
                        style={{
                            width: '100%',
                            maxWidth: '248px',
                            padding: '14px 24px',
                            fontFamily: 'Manrope',
                            fontWeight: 600,
                            fontSize: '16px',
                            color: '#F7FAFC',
                            background: '#015FA6',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'background-color 0.2s ease',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.background = '#014880'}
                        onMouseLeave={(e) => e.currentTarget.style.background = '#015FA6'}
                    >
                        Go to Dashboard
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Right Side - Hero */}
            <div className="hidden lg:flex lg:flex-1" style={{ background: '#015FA6' }}>
                <AuthHero />
            </div>
        </div>
    );
};

/**
 * JoinSuccess Page
 * Protected by FlowGuard - only accessible after team join flow
 * Direct URL access redirects to login page
 */
const JoinSuccess: React.FC = () => {
    return (
        <FlowGuard
            requiredStateKey="fromJoinTeam"
            fallbackPath="/auth/login"
        >
            <JoinSuccessContent />
        </FlowGuard>
    );
};

export default JoinSuccess;
